import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    ElementRef,
    inject,
    signal,
    viewChild
} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ComponentTooltip, ComponentTooltipService} from '../components/component-tooltip/component-tooltip.service';
import {DynamicComponentBase} from '../service/ng-dynamic-components.service';
import {TooltipChangeConflictComponent} from '../components/tooltip-change-conflict/tooltip-change-conflict.component';
import {randomInt} from 'es-toolkit';


@Component({
    selector: 'test-tooltip-hint',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [],
    template: `
        <div class="layout-vbox" style="align-items: flex-start; gap: 10px">
            <div>{{text()}}</div>
        </div>
    `,
    styles: `
    `
})
export class TooltipHintComponent extends DynamicComponentBase {
    protected readonly text = signal('This is the first message.');

    constructor() {
        super();
        setTimeout(() => this.text.set('This is the second message.'), 10_000);
    }
}

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        FormsModule, TooltipHintComponent, TooltipChangeConflictComponent
    ],
    template: `
        <div class="layout-vbox" style="align-items: flex-start; gap: 10px">
            <div class="layout-hbox" style="gap: 10px">
                <div class="flower" style="border: 1px solid darkgrey; padding: 5px" #ttEl1>Mouse over for toolip</div>
                <div class="flower" style="border: 1px solid darkgrey; padding: 5px" #ttEl2>Other toolip</div>
            </div>
            <test-tooltip-hint class="component-border"></test-tooltip-hint>
            <app-tooltip-change-conflict changedBy="alexander.heim@generali.co.uk"></app-tooltip-change-conflict>
            <label><input type="checkbox" [(ngModel)]="isConflict">Conflict</label>
            <fluent-button (click)="removeFromEl2()">Remove from EL2</fluent-button>
        </div>
    `,
    styles: `
        app-tooltip-change-conflict {
            width: 400px;
            height: auto;
            overflow: auto;
        }
    `
})
export class TestComponentTooltipComponent implements AfterViewInit {

    private ttEl1 = viewChild.required<ElementRef<HTMLDivElement>>('ttEl1');
    private ttEl2 = viewChild.required<ElementRef<HTMLDivElement>>('ttEl2');

    private readonly compTooltipSvc = inject(ComponentTooltipService);

    protected readonly isConflict = signal(false);

    private tt: ComponentTooltip<TooltipHintComponent>;
    private tt2: ComponentTooltip<TooltipChangeConflictComponent>;

    constructor() {
        this.tt = this.compTooltipSvc.create(TooltipHintComponent, {
            input: { markdown: 'No text' },
            beforeShow: this.beforeTtShow.bind(this)
        });
        this.tt2 = this.compTooltipSvc.create(TooltipChangeConflictComponent, {
            width: '400px',
            height: 'auto',
            padding: '0px',
            isResizable: true,
            beforeShow: this.beforeTt2Show.bind(this)
        });
    }

    ngAfterViewInit() {
        this.tt.setTooltip(this.ttEl1(), 'This is the first element.');
        this.tt2.setTooltip(this.ttEl2(), 'This is the second element.');
    }

    private beforeTtShow (tt: ComponentTooltip<any>, el: HTMLElement, init: any, data: string) {
        init.markdown = data;
    }

    private beforeTt2Show (tt: ComponentTooltip<any>, el: HTMLElement, init: any, data: string) {
        const emails =  ["lipeng@verizon.net", "bowmanbs@verizon.net", "rmcfarla@msn.com", "boser@aol.com"]
        init.changedBy = emails[randomInt(0, emails.length)];
        init.changedAt = new Date();
        init.isConflict = this.isConflict();
    }

    removeFromEl2() {
        this.tt.removeTooltip(this.ttEl2());
    }

    protected readonly Date = Date;
}
